import _regeneratorRuntime from "C:\\Users\\NikolajKniha\\Desktop\\Personal\\Bachelor\\bachelor\\node_modules\\@babel\\runtime/regenerator";
import _asyncToGenerator from "C:\\Users\\NikolajKniha\\Desktop\\Personal\\Bachelor\\bachelor\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";

function auth(_x) {
  return _auth.apply(this, arguments);
}
/**
 * Prefix token for usage in the Authorization header
 *
 * @param token OAuth token or JSON Web Token
 */


function _auth() {
  _auth = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(token) {
    var tokenType;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            tokenType = token.split(/\./).length === 3 ? "app" : /^v\d+\./.test(token) ? "installation" : "oauth";
            return _context.abrupt("return", {
              type: "token",
              token: token,
              tokenType: tokenType
            });

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _auth.apply(this, arguments);
}

function withAuthorizationPrefix(token) {
  if (token.split(/\./).length === 3) {
    return "bearer ".concat(token);
  }

  return "token ".concat(token);
}

function hook(_x2, _x3, _x4, _x5) {
  return _hook.apply(this, arguments);
}

function _hook() {
  _hook = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2(token, request, route, parameters) {
    var endpoint;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            endpoint = request.endpoint.merge(route, parameters);
            endpoint.headers.authorization = withAuthorizationPrefix(token);
            return _context2.abrupt("return", request(endpoint));

          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _hook.apply(this, arguments);
}

var createTokenAuth = function createTokenAuth(token) {
  if (!token) {
    throw new Error("[@octokit/auth-token] No token passed to createTokenAuth");
  }

  if (typeof token !== "string") {
    throw new Error("[@octokit/auth-token] Token passed to createTokenAuth is not a string");
  }

  token = token.replace(/^(token|bearer) +/i, "");
  return Object.assign(auth.bind(null, token), {
    hook: hook.bind(null, token)
  });
};

export { createTokenAuth };